import * as React from "react";
import { ProductCollectionCatalogsView } from "components/product-collection/product-collection-views/product-collection-catalogs-view";
import RefineIcon from "components/icons/refine";
import IconMenu from "material-ui/IconMenu";
import IconButton from "material-ui/IconButton";
import theme from "styles/theme";
import { formatMessage } from "lib/globalize-util";
import MenuItem from "material-ui/MenuItem";
import { HEADER_HEIGHT } from "./shop-tool-panel";
import { Location } from "history";
import { RouterState, InjectedRouter } from "react-router";
import type { IScope } from "reducers/scope";

interface IProps {
    app: any;
    location: Location;
    onFetchCatalog: (id) => void;
    children: React.ReactNode;
    onSnackbarAdd: (params) => void;
    scope: IScope;
    brandEntities: any;
    brandIds: string[];
    catalogIds: string[];
    isFetchingCatalogs: boolean;
    catalogEntities: any;
    onFetchCatalogs: (query) => void;
    onFetchCatalogsNextPage: (nextPage) => void;
    catalogsNextPage: any;
    isFetchingBrand: boolean;
    onFetchBrand: (brandId) => void;
    catalogType: "linesheet" | "custom-list";
    router: RouterState & InjectedRouter;
}

export const Catalogs: React.FunctionComponent<IProps> = ({
    app,
    location,
    scope,
    brandEntities,
    brandIds,
    catalogIds,
    isFetchingCatalogs,
    catalogEntities,
    onFetchCatalogs,
    onFetchCatalogsNextPage,
    catalogsNextPage,
    catalogType,
    router,
    children,
}) => {
    const catalogValues = React.useMemo(() => {
        return [
            { value: undefined, label: formatMessage("All Catalogs") },
            { value: "linesheet", label: formatMessage("Linesheets") },
            { value: "custom-list", label: formatMessage("Custom Lists") },
        ];
    }, []);

    const handleCatalogTypeChange = React.useCallback(
        (e, value: string) => {
            const { pathname, query } = location;
            router.push({
                pathname,
                query: {
                    ...query,
                    type: value,
                },
            });
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [location]
    );

    return (
        <React.Fragment>
            <div className="shopHeader">
                {children}
                <IconMenu
                    value={catalogType}
                    onChange={handleCatalogTypeChange}
                    iconButtonElement={
                        <IconButton>
                            <RefineIcon color={theme.palette.darkGrey} hoverColor={theme.palette.darkerGrey} />
                        </IconButton>
                    }
                >
                    {catalogValues.map(({ value, label }, i) => (
                        <MenuItem key={i} value={value} primaryText={label} />
                    ))}
                </IconMenu>
            </div>
            <ProductCollectionCatalogsView
                app={app}
                location={location}
                router={router}
                scope={scope}
                entities={brandEntities}
                ids={brandIds}
                catalogIds={catalogIds}
                catalogEntities={catalogEntities}
                isFetchingCatalogs={isFetchingCatalogs}
                brandId={scope.brand?._id}
                onFetchCatalogs={onFetchCatalogs}
                onFetchCatalogsNextPage={onFetchCatalogsNextPage}
                catalogsNextPage={catalogsNextPage}
                catalogType={catalogType}
                overrideStyles={{ headerHeight: HEADER_HEIGHT }}
            />
        </React.Fragment>
    );
};
